import axios from "axios"
import {toLocaleString} from "../Common/utils";

Date.prototype.toLocaleString = function () {
  return this.getFullYear() + "-" + (this.getMonth() + 1) + "-" + this.getDate() + " " + this.getHours() + ":" + this.getMinutes() + ":" + this.getSeconds();
};
// const
const ENTERPRISE_LIST_STORE_DATA = "enterpriseList/ENTERPRISE_LIST_STORE_DATA";
const ENTERPRISE_LIST_UPDATE_DATA = "enterpriseList/ENTERPRISE_LIST_UPDATE_DATA";
const REDIRECT_TO_ENTERPRISE_DETAILS = "enterpriseList/REDIRECT_TO_ENTERPRISE_DETAILS";
const ENTERPRISE_LIST_STORE_STATUS = "enterpriseList/ENTERPRISE_LIST_STORE_STATUS"
// reducer
export const enterpriseList = (state = {
  showEnterprises: [],
  enterpriseStatuses: [],
  enterpriseStatus: 0,
  enterpriseName: "",
  selectedEnterpriseId: "",
  selectedEnterpriseStatus: 0,
  startTime: "2001-01-01 00:00:00",
  endTime: "2038-01-19 08:00:00",
  page:0,
  size: 5,
  total: 0,

}, action) => {
  switch (action.type) {
    case ENTERPRISE_LIST_STORE_DATA:
      return {
        ...state,
        showEnterprises: action.data.map(enterprise => {
          enterprise.key = enterprise.name;
          if (enterprise.lastAuthTime !== null) {
            enterprise.lastAuthTime = toLocaleString(enterprise.lastAuthTime);
          }
          else
            enterprise.lastAuthTime = "";
          enterprise.submitTime = toLocaleString(enterprise.submitTime);
          return enterprise;
        })
      };
    case ENTERPRISE_LIST_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case REDIRECT_TO_ENTERPRISE_DETAILS:
      return {
        ...state,
        selectedEnterpriseId: action.data.id,
        selectedEnterpriseStatus: action.data.status.id,
      };
    case ENTERPRISE_LIST_STORE_STATUS:
      return {
        ...state,
        enterpriseStatuses: action.data
      };
    default:
      return state
  }
};

/**
 * store all enterprises
 */
export const storeEnterprises = (enterprises) => {
  return {
    type: ENTERPRISE_LIST_STORE_DATA,
    data: enterprises
  }
};

/**
 * get all enterprises
 */
export const getEnterprises = (data) => (dispatch) => {
  dispatch(storeEnterprises(data));
};

export const updateData = (data) => {
  return {
    type: ENTERPRISE_LIST_UPDATE_DATA,
    data: data
  }
};

export const filterEnterprise = (data) => (dispatch) => {
  let showEnterprises = data.enterprises.filter(enterprises => {
    return enterprises.name.indexOf(data.name) > -1
  });
  dispatch(updateData({
    name: "showEnterprises",
    value: showEnterprises
  }));
};

/**
 * 前页跳转此页，需要传递参数：enterprise.name
 */
export function toDetails(name) {
  return {
    type: REDIRECT_TO_ENTERPRISE_DETAILS,
    data: name
  };
}

export function storeStatuses(data) {
  return {
    type: ENTERPRISE_LIST_STORE_STATUS,
    data: data
  };

}

export const getEnterpriseStatuses = () => (dispatch) => {
  axios.get("/api-user/verifyStatuses", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeStatuses(response.data._embedded.verifyStatuses));
      }
    }
  );
}




